function Content({content}){
  return(
    <>
      {content}
    </>
  );
}

export default Content
